import { FC } from 'react';
import { PaymentElement, PaymentElementProps } from '@stripe/react-stripe-js';

export interface StripePaymentElementProps extends PaymentElementProps {}

export const StripePaymentElement: FC<StripePaymentElementProps> = props => (
  <PaymentElement
    {...props}
    options={{
      // To disable these fields in the form, we have to pass the billing country at "confirm-time"
      fields: { billingDetails: { address: { country: 'never', postalCode: 'never' } } },
      terms: { card: 'never' },
      ...props.options
    }}
  />
);
